<template>
  <v-container fluid grid-list-md>
    <v-card class="mx-auto">
      <v-card-text class="headline font-weight-bold">
        <v-card-actions class="headline font-weight-bold">
          <h3>{{ partner.name }}</h3>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-chip :class="partner">
          <i class="white--text">
            {{ onCaptalize($t(`partner.${partner.partner}`)) }}</i
          >
        </v-chip>
      </v-card-text>

      <v-btn color="indigo darken-2" dark @click.stop="goTo('partners')">
        Voltar
      </v-btn>
    </v-card>
    <partner-details />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Details",
  computed: {
    ...mapGetters({
      partner: "partners/partner",
      isLoad: "partners/isLoad",
    }),
  },
  created() {
    this.$store.dispatch("partners/get");
  },
  components: {
    PartnerDetails: () => import("@/components/desktop/partners/Details.vue"),
  },
  methods: {
    goTo(route) {
      this.$router.push({ name: route });
      this.hideNavigation();
    },
    onCaptalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>
<style >
.v-chip.partner {
  background-color: #1b5e20 !important;
}
</style>
